<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeFeedProductsSearchDropDownFilters"
  >
    <form
      autocomplete="off"
      spellcheck="false"
      @submit.prevent="searchFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Productos
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <div
                v-for="(activeType, index) in activeTypes"
                :key="index"
              >
                <AtomRadioButtonPrimary
                  v-model.number="filter.active"
                  :radio-button-primary="radioButtonPrimary.activeType"
                  :text="activeType.name"
                  :value="activeType.id"
                  wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                />
              </div>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Estado de venta
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(state, index) in states"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.state"
                    inputStyle="products"
                    name="estado"
                    :text="state.name"
                    :value="state.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Visibilidad en Tienda
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(visible, index) in visibility"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.visible"
                    inputStyle="products"
                    name="visibilidad"
                    :text="visible.name"
                    :value="visible.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              Orden
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <div
                v-for="(sortType, index) in sortTypes"
                :key="index"
              >
                <AtomRadioButtonPrimary
                  v-model.number="filter.sort_type"
                  v-show="sortType.id !== 1 || (sortType.id === 1 && filter.project_type !== 11)"
                  :disabled="sortType.id === 1 && filter.project_type === 11"
                  :radio-button-primary="radioButtonPrimary.sortType"
                  :text="sortType.name"
                  :value="sortType.id"
                  wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                />
              </div>
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reload"
        >
          Actualizar
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          Filtrar
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedProductsSearchDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      radioButtonPrimary: {
        sortType: {
          labelClass: 'a-radiobutton-products-primary font-size-small',
          name: 'sort-type'
        },

        activeType: {
          labelClass: 'a-radiobutton-products-primary font-size-small',
          name: 'active-type'
        }
      },

      filter: {
        name: '',
        active: -1,
        sort_type: 0,
        state: [0, 1],
        visible: [0, 1]
      },

      activeTypes: [
        {
          id: -1,
          name: 'Todos'
        },

        {
          id: 1,
          name: 'Pagos'
        },

        {
          id: 0,
          name: 'Gratis'
        }
      ],

      sortTypes: [
        {
          id: 0,
          name: 'Predeterminado'
        },

        {
          id: 1,
          name: 'Fecha de Creación'
        },

        {
          id: 2,
          name: 'Alfabético A-Z'
        }
      ],

      states: [
        {
          id: 0,
          name: 'Habilitada'
        },

        {
          id: 1,
          name: 'Deshabilitada'
        }
      ],

      visibility: [
        {
          id: 0,
          name: 'Visible'
        },

        {
          id: 1,
          name: 'Oculto'
        }
      ]
    }
  },

  watch: {
    filterSeted: {
      deep: true,

      handler () {
        this.filter = Object.assign({}, this.filterSeted)
      }
    }
  },

  methods: {
    reload () {
      this.filter = {
        name: '',
        active: -1,
        sort_type: 0,
        state: [0, 1],
        visibility: [0, 1]
      }

      this.$emit('reload')
    },

    searchFilter () {
      this.$dropDown.switchDropDown('MoleculeFeedProductsSearchDropDownFilters')
      this.$emit('searchFilter', this.filter)
    }
  }
}
</script>
